import { cn } from "admin-ui/utils/cn"
import { IconProps } from "."

export default function Link({
  className,
  transform,
  ...reset
}: Readonly<IconProps>) {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("h-6 w-6", className)}
      transform={transform}
      {...reset}
    >
      <path
        d="M15.0229 12.6522L13.9624 11.5902L15.0229 10.5297C15.3737 10.182 15.6523 9.7685 15.8428 9.31287C16.0332 8.85725 16.1318 8.36849 16.1329 7.87465C16.134 7.38081 16.0375 6.89162 15.8491 6.43517C15.6606 5.97871 15.3838 5.56398 15.0346 5.21479C14.6854 4.86559 14.2707 4.5888 13.8142 4.40032C13.3578 4.21183 12.8686 4.11536 12.3747 4.11645C11.8809 4.11753 11.3921 4.21614 10.9365 4.40662C10.4809 4.5971 10.0674 4.8757 9.7197 5.22642L8.6592 6.28767L7.59795 5.22717L8.65995 4.16667C9.64456 3.18206 10.98 2.62891 12.3724 2.62891C13.7649 2.62891 15.1003 3.18206 16.0849 4.16667C17.0696 5.15129 17.6227 6.48672 17.6227 7.87917C17.6227 9.27163 17.0696 10.6071 16.0849 11.5917L15.0237 12.6522H15.0229ZM12.9019 14.7732L11.8407 15.8337C10.8561 16.8183 9.52066 17.3714 8.1282 17.3714C6.73574 17.3714 5.40031 16.8183 4.4157 15.8337C3.43108 14.8491 2.87793 13.5136 2.87793 12.1212C2.87793 10.7287 3.43108 9.39329 4.4157 8.40867L5.47695 7.34817L6.53745 8.41017L5.47695 9.47067C5.12622 9.81834 4.84763 10.2319 4.65714 10.6875C4.46666 11.1431 4.36805 11.6319 4.36697 12.1257C4.36589 12.6195 4.46236 13.1087 4.65084 13.5652C4.83933 14.0216 5.11611 14.4364 5.46531 14.7856C5.81451 15.1348 6.22924 15.4115 6.68569 15.6C7.14215 15.7885 7.63133 15.885 8.12517 15.8839C8.61901 15.8828 9.10777 15.7842 9.5634 15.5937C10.019 15.4032 10.4325 15.1246 10.7802 14.7739L11.8407 13.7134L12.9019 14.7739V14.7732ZM12.3709 6.81792L13.4322 7.87917L8.12895 13.1817L7.0677 12.1212L12.3709 6.81867V6.81792Z"
        fill="currentColor"
      />
    </svg>
  )
}
